import axios from 'axios';
import { CONTRACT_URI } from '../api/apiVersionConstants';

export default {
    async getCustomerContracts(customerId, centralCustomerId) {
        return axios.get(`${CONTRACT_URI}/getCustomerContracts/${customerId}?centralCustomerId=${centralCustomerId}`);
    },
    async getContractUnitInfo(contractNumber) {
        return axios.get(`${CONTRACT_URI}/${contractNumber}`);
    }
};